<div>
  <i class="pbi-icon-outline pbi-warning-triangle"></i>
  <p>Sample video for reporting purposes. Do not share with end viewer.</p>
</div>
